let metadata = {
    "prequal.yoursurgecard.com" : {
        "title"       : "Surge® Mastercard® - See if you're pre-approved",
        "description" : "Check to see if you have a pre-approved Surge Mastercard offer.",
        "keywords"    : "Surge Mastercard, Continental Finance, Double Credit Limit, Credit Cards for Bad Credit, credit card application",
        "author"      : "Continental Finance Company, LLC",
        "og:type"     : "website",
        "og:title"    : "Surge® Mastercard® - See if you're pre-approved",
        "og:description" : "Check to see if you have a pre-approved Surge Mastercard offer.",
        "og:image"       : "https://images.continentalfinance.net/applicationweb/Surge/banner.png",
    },
    "localhost" : {
        "title"       : "Surge® Mastercard® - See if you're pre-approved",
        "description" : "Check to see if you have a pre-approved Surge Mastercard offer.",
        "keywords"    : "Surge Mastercard, Continental Finance, Double Credit Limit, Credit Cards for Bad Credit, credit card application",
        "author"      : "Continental Finance Company, LLC",
        "og:type"     : "website",
        "og:title"    : "Surge® Mastercard® - See if you're pre-approved",
        "og:description" : "Check to see if you have a pre-approved Surge Mastercard offer.",
        "og:image"       : "https://images.continentalfinance.net/applicationweb/Surge/banner.png"
    }
}

export default metadata